document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header-component');
  if (!header) return;

  const row = header.querySelector('.header__row');
  if (!row) return;

  // Detect touch support
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // ✅ Desktop hover behavior
  if (!isTouch) {
    header.addEventListener('mouseenter', () => {
      header.classList.add('is_active');
      row.classList.add('header-active');
    });

    header.addEventListener('mouseleave', () => {
      header.classList.remove('is_active');

      if (header.getAttribute('data-scroll-direction') === 'up') {
        row.classList.add('header-active');
      } else {
        row.classList.remove('header-active');
      }
    });
  }

  // ✅ Scroll direction tracking (works on both desktop & mobile)
  const observer = new MutationObserver(() => {
    if (header.getAttribute('data-scroll-direction') === 'up') {
      row.classList.add('header-active');
    } else {
      row.classList.remove('header-active');
    }
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['data-scroll-direction']
  });
});